import { get, post } from "./api";

export const getAdjustmentData = (id, formattedDate, signal) => {
  const url = `/api/v2/customers/${id}/accountadjustment/${formattedDate}/`;
  return get(url, {}, false, signal, true);
};

export const postAdjustmentData = (id, data, formattedDate, signal) => {
  const url = `/api/v2/customers/${id}/accountadjustment/${formattedDate}/`;
  return post(url, data);
};
